export default __webpack_public_path__ + "static/media/winston-churchill.4a24d22c.png";